export enum ClientCategoryType {
  NonResident = 'NonResident',
  Resident = 'Resident',
  // for global
  AIFCParticipant = 'AIFCParticipant',
  AfricaResidence = 'AfricaResidence',
  AmericasResidence = 'AmericasResidence',
  AsiaResidenceExceptCentralAsia = 'AsiaResidenceExceptCentralAsia',
  AustraliaResidence = 'AustraliaResidence',
  CentralAsiaResidenceExceptKazakhstan = 'CentralAsiaResidenceExceptKazakhstan',
  EuropeResidence = 'EuropeResidence',
  KazakhstanResidenceExceptAIFCParticipants = 'KazakhstanResidenceExceptAIFCParticipants',
  RussianFederationResidence = 'RussianFederationResidence',
}
